import React, { ComponentType, FC, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PublicRoute from './publicRoute';
import { isReauthRequest } from './reauthLogin';
import { hasStoredSession } from './storedSession';

type GuestRouteProps = {
    component: ComponentType
};

const GuestRoute: FC<GuestRouteProps> = ({ component, ...rest }): ReactElement => {
    const { search } = useLocation();
    // Reconnexion ouverte depuis un autre onglet : le jeton en place est périmé ou va l'être.
    if (hasStoredSession() && !isReauthRequest(search)) {
        return <Navigate to="/" replace />;
    }
    return <PublicRoute component={ component } { ...rest } />;
};

export default GuestRoute;
